import CustomIcons from "../GlobalComponents/CustomIcons";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { setNavbar } from "../Actions/Home_Actions";

class NavbarV2 extends Component {
  state = {
    loading: false,
    isMobileMenuOpen: false,
    showMenu1: false,
    showMenu2: false,
    menu1: {},
    menu2: {},
    listMenu: []
  };

  componentDidMount = () => {

    if(this.props.navbar && this.props.navbar != '') {
      this.formatNavbar(this.props.navbar)
    } else if(this.props.listMenu) {
      this.setState({
        listMenu: this.props.listMenu
      })
      this.formatNavbar(this.props.listMenu)
    }
  };

  toggleMobileMenu = () => {
    this.setState({ isMobileMenuOpen: !this.state.isMobileMenuOpen });
  };

  toggleDropdown = (menu) => {
    let _this = this;

    let ocultar = menu == "showMenu1" ? "showMenu2" : "showMenu1";

    _this.setState((prevState) => ({
      [ocultar]: false,
      [menu]: !prevState[menu],
    }));
  };

  formatNavbar = (navbar) => {

    if(!navbar.menu2) {
      return
    }

    this.setState({
      menu1: navbar.menu1,
      menu2: navbar.menu2,
    }, () => {
    });
  };

  componentDidUpdate(prevProps, prevState) {
 
    if (this.props.listMenu && this.state.listMenu !== this.props.listMenu) {
      this.setState({
        listMenu: this.props.listMenu
      })
      this.formatNavbar(this.props.listMenu)
    }
  }

  failureDataResponse = (error) => {
    console.log("ERROR: ", error);
  };

  renderDropdown = (name, options, show) => {
    return (
      <div
        className="navbarv2-dropdown"
        onClick={() => this.toggleDropdown(show)}
      >
        <button
          className={this.state[show] ? "mainLink mainLinkHover" : "mainLink"}
        >
          {name}{" "}
          <CustomIcons
            icon={!this.state[show] ? "dropdownArrow" : "dropdownArrowUp"}
          />
        </button>
        {this.state[show] && (
          <div
            className="navbarv2-dropdown-content"
            onMouseLeave={() => this.toggleDropdown(show)}
          >
            {options.sort(this.orderMenu).map((section, index) => {
              return (
                <div>
                  <p className="navbarv2-dropdown-title">
                    {section.name.toUpperCase()}
                  </p>
                  <div className="navbarv2-dropdown-links">
                    {section.options.map((item, key) => {
                      if (item.active) {
                        if (item.page) {
                          return (
                            <Link
                              className="navbarv2-dropdown-link"
                              to={
                                this.props.mainpage
                                  ? `mainpage/${item.content_id}`
                                  : `${item.content_id}`
                              }
                            >
                              {item.name}
                            </Link>
                          );
                        } else {
                          return (
                            <a
                              target="_blank"
                              href={`${item.url}`}
                              rel="noopener noreferrer"
                              className="navbarv2-dropdown-link"
                            >
                              {item.name}
                            </a>
                          );
                        }
                      }
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  orderMenu = (a, b) => {
    if (a.order > b.order) {
      return 1;
    }
    if (a.order < b.order) {
      return -1;
    }
    return 0;
  };
  renderMenuMobile = (menu) => {
    return menu.options.sort(this.orderMenu).map((section, index) => {
      return (
        <>
          <div className="sectionTitleStyle">{section.name}</div>
          {section.options.map((item, key) => {
            if (item.active) {
              if (item.page) {
                return (
                  <Link
                    className="menuItemStyle"
                    to={
                      this.props.mainpage
                        ? `mainpage/${item.content_id}`
                        : `${item.content_id}`
                    }
                  >
                    {item.name} <CustomIcons icon="shortArrowRight" className={'icon-arrow'}/>
                  </Link>
                );
              } else {
                return (
                  <a
                    target="_blank"
                    href={`${item.url}`}
                    rel="noopener noreferrer"
                    className="menuItemStyle"
                  >
                    {item.name} <CustomIcons icon="shortArrowRight" className={'icon-arrow'}/>
                  </a>
                );
              }
            }
          })}
        </>
      );
    });
  };

  render() {
    const { isMobileMenuOpen,menu2, menu1 } = this.state;
    return (
      <div className="navbarv2-container">
        <nav className="navbarv2">
          <Link to="/" className="navbarv2-logo">
            <CustomIcons icon="logo20min" />
          </Link>

          <div className="navbarv2-menuItems">


            {!this.props.login &&
              <Link to="/consulta" className="mainLink">
                Pago ágil PSE
              </Link>
            }

            {Object.keys(menu1).length > 0 &&
              this.renderDropdown(
                this.state.menu1.options[0].name,
                this.state.menu1.options,
                "showMenu1"
              )}

            {Object.keys(menu2).length > 0 &&
              this.renderDropdown(
                this.state.menu2.name,
                this.state.menu2.options,
                "showMenu2"
              )}

          </div>

          {!this.props.login ? (
            <div className="navbarv2-login">

              <div className="curved-button">
                <Link className="corniza" to="/login">
                  <CustomIcons icon="login" /> Iniciar Sesión
                </Link>

              </div>

              <button
                className="navbarv2-hamburger"
                onClick={this.toggleMobileMenu}
              >
                <CustomIcons icon="hamburger" className="icon" />
              </button>
            </div>
          ) : (
            <div className="navbarv2-login-v2">
              <div className="curved-button">
                <Link className="corniza" to="/consulta">
                  Pago ágil PSE
                </Link>
              </div>

              <button
                className="navbarv2-hamburger"
                onClick={this.toggleMobileMenu}
              >
                <CustomIcons icon="hamburger" className="icon" />
              </button>
            </div>
          )}

          <div
            class={isMobileMenuOpen ? "overlay active" : "overlay"}
            id="sidebarOverlay"
          ></div>

         

          <div
            className={
              isMobileMenuOpen ? "containerStyle open" : "containerStyle closed"
            }
          >
            <div className="menu-mobile">
              <Link to="consulta" className="menuItemStyle">
                Pago ágil PSE <CustomIcons icon="shortArrowRight" />
              </Link>

              {Object.keys(menu2).length > 0 && this.renderMenuMobile(menu2)}

              {Object.keys(menu1).length > 0 && this.renderMenuMobile(menu1)}
            </div>
          </div>
        </nav>

        <div
            className={
              isMobileMenuOpen ? "headerStyle open" : "headerStyle closed"
            }
          >
            <p>Menú Principal</p>

            <button
              className="closeButtonStyle"
              onClick={this.toggleMobileMenu}
            >
              <CustomIcons icon="closeHamburger" />
            </button>
          </div>
      </div>
    );
  }
}



const mapStateToProps = state => ({
  navbar: state.navbar.Navbar
})

export default connect(mapStateToProps, { setNavbar })(NavbarV2)


